import { NgModule } from '@angular/core';

import { SharedModule }   from '../shared/shared.module';
import { UserComponent }  from './user.component';
import { UserService }    from './user.service';

@NgModule({
  declarations: [
    UserComponent
  ],
  entryComponents: [
    UserComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    UserService
  ]
})
export class UsersModule {}
